import { Component, OnInit } from '@angular/core';
import {
  PrTable,
  PrTableColumn,
} from '@app/components/pr-table/pr-table.component';
import { Product } from '@app/forms/subscription/definition/interface/Pledge';
import { SubscriptionFacadeService } from '@app/forms/subscription/services/subscription-facade.service';
import * as _ from 'lodash';

@Component({
    selector: 'scpi-table',
    templateUrl: './scpi-table.component.html',
    styleUrls: ['./scpi-table.component.scss'],
    standalone: false
})
export class ScpiTableComponent implements OnInit {
  _ = _;
  data: Product[];
  tableData;
  tableDefinitionColumn: PrTableColumn[];

  constructor(private subscriptionFacade: SubscriptionFacadeService) {
    this.tableData = new PrTable([], this.tableDefinitionColumn);
  }

  ngOnInit(): void {
    const pledge = this.subscriptionFacade.getPledge();
    this.data = pledge?.products;

    this.tableDefinitionColumn = [
      new PrTableColumn('Noms des SCPI', 'productName'),
      new PrTableColumn('Parts', 'scpiNbPart', {
        hasTotal: true,
      }),

      new PrTableColumn('Montant investi', 'scpiInvestmentPrice', 'currency', {
        hasTotal: true,
      }),
      new PrTableColumn('Repartition', 'repartition', {
        hasTotal: true,
        suffix: '%',
      }),
    ];
    this.initTable();
  }
  get total() {
    return _.sumBy(
      this.data,
      product => product?.parameters.scpiInvestmentPrice,
    );
  }
  initTable() {
    let table = this.data.map(product => {
      return {
        productName: product.productName,
        repartition: Math.round(
          (product?.parameters.scpiInvestmentPrice / this.total) * 100,
        ),
        scpiPartPrice: product?.parameters.scpiPartPrice,
        scpiInvestmentPrice: product?.parameters.scpiInvestmentPrice,
        scpiNbPart: product?.parameters.scpiNbPart,
      };
    });
    this.tableData = new PrTable(table, this.tableDefinitionColumn);
  }
  next() {
    this.subscriptionFacade.nextStep();
  }
  prev() {
    this.subscriptionFacade.previousStep();
  }
}
